// extracted by mini-css-extract-plugin
module.exports = {"newsletter_card":"styles_newsletter_card__JpgkY","header":"styles_header__wNuFz","fade-out":"styles_fade-out__pgw4J","fade-in":"styles_fade-in__YF9TA"};